export const AppConfig = {
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL,
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
  YANDEX_GEOCODER_API_KEY: process.env.REACT_APP_YANDEX_GEOCODER_API_KEY,
  YANDEX_GEOSUGGEST_API_KEY: process.env.REACT_APP_YANDEX_GEOSUGGEST_API_KEY,
  API_URL: `${process.env.REACT_APP_BASE_API_URL}/v1/admin`,
};
